import { render, staticRenderFns } from "./WagesReports.vue?vue&type=template&id=401dfce2&"
import script from "./WagesReports.vue?vue&type=script&lang=js&"
export * from "./WagesReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('401dfce2')) {
      api.createRecord('401dfce2', component.options)
    } else {
      api.reload('401dfce2', component.options)
    }
    module.hot.accept("./WagesReports.vue?vue&type=template&id=401dfce2&", function () {
      api.rerender('401dfce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/reports/WagesReports.vue"
export default component.exports